<template>
  <div class="registration" v-loading="loading">
    <div class="layout-page-heading">
      <div class="iconClock">
        <img src="../../assets/img/iconPro.png" alt="" />
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>设置-产品</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="layout-page-box">
      <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
        <el-form-item label="诊断">
          <el-input v-model="filters.diagnose" clearable></el-input>
        </el-form-item>
        <el-form-item label="规范手术名称">
          <el-input v-model="filters.operationName" clearable></el-input>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
      <div class=" buttonText">
        <div class="delete" @click="del">删除</div>
        <div class="addData" @click="add">新增</div>
      </div>
    </div>
    <div class="layout-page-box">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{ color: '#626365' }">
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- <el-table-column prop="id" label="编号" width="100"></el-table-column> -->
        <el-table-column prop="menuName" label="诊断"></el-table-column>
        <el-table-column prop="operationName" label="规范手术名称"></el-table-column>
        <el-table-column prop="registrationType" label="登记表">
          <template slot-scope="scope">
            <span v-if="scope.row.registrationType==1">外科</span>
            <span v-if="scope.row.registrationType==2">皮肤科</span>
          </template>
        </el-table-column>
        <el-table-column prop="createBy" label="添加人" width="150"></el-table-column>
        <el-table-column prop="createTime" label="添加时间" width="150"></el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
    <!-- 外科新增和编辑弹框 -->
    <el-dialog :visible.sync="editSkinDialog" v-if="editSkinDialog" width="50%" center class="dialogItem" :close-on-click-modal="false">
      <editDiagnosis :code="code" :formData="formData" @closeDialog="closeDialog" @add-comment="appendComment"></editDiagnosis>
    </el-dialog>
  </div>
</template>
<script>
import Store from "../../assets/common.vue";
import editDiagnosis from "./editDiagnosis.vue";
export default {
  components: {
    editDiagnosis
  },
  data() {
    return {
      formData: {},
      filters: {
        types: "",
        pagination: {
          page: 1,
          limit: 10,
          total: 0,
        },
        operationName: '',
        diagnose: '',
        startTime: "",
        endTime: "",
      },
      tableData: [],
      loading: false,
      productOption: Store.productOption,
      editSkinDialog: false,
      tableHeight: ''
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page;
      this.refresh();
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes;
      this.refresh();
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge(
          {},
          this.$route.query,
          {
            __query: JSON.stringify(this.pagination),
          },
          {
            random: Math.random(),
          }
        ),
      });
    },
    search() {
      this.filters.pagination.page = 1
      this.refresh()
    },
    // 新增注射科登记表
    add() { },
    // 查询
    query(page) {
      let querys = {
        startTime: "",
        endTime: "",
        page: page,
        size: this.filters.pagination.limit,
        operationName: this.filters.operationName,
        diagnose: this.filters.diagnose,
      };
      if (this.filters.startTime) {
        querys.startTime = this.filters.startTime[0];
        querys.endTime = this.filters.startTime[1];
      }
      api.request(
        "/register/findDiagnoseList",
        querys,
        (res) => {
          // console.log(res)
          var data = res.data.list;
          this.tableData = data;
          this.tableData.forEach((ele) => {
            ele.opear = "/";
          });
          this.filters.pagination.total = parseInt(res.data.count);
        }
      );
    },
    // 编辑
    handleEdit(index, row) {
      console.log(row);
      this.editSkinDialog = true
      this.code = 1
      api.request(
        "/register/findRegisterMenuDiagnoseById",
        { registerMenuId: row.id },
        (res) => {
          console.log(res)
          this.formData = res.data
          this.formData.id = row.id
        }
      );
    },
    add() {
      this.editSkinDialog = true
      this.code = 0//1编辑0新增
      this.formData = {
        type: '',
        diagnoseList: [{
          operationName: '',
        }],
        operationNameList: [{
          menuName: ''
        }],
        registrationType: ''
      }
    },
    // 删除项目
    del() {
      var data = this.multipleSelection;
      var id = [];
      data.map(function (item, index) {
        id.push(item.id);
      });
      this.$confirm("确定要删除选中的数据吗？", "删除项目", {
        center: true,
      })
        .then((res) => {
          api.requestQuiet("/register/deleteRegisterMenuDiagnose", { registerMenuId: id.join('，') },
            (res) => {
              if (res.result == true) {
                _g.toast("success", "删除成功");
                this.query(this.filters.pagination.page);
              } else {
                _g.toast("error", "删除失败");
                this.query(this.filters.pagination.page);
              }
            }
          );
        })
        .catch((err) => {
          // this.$message.error('删除失败！');
        });
    },
    closeDialog() {
      this.editSkinDialog = false
    },
    // 子组件添加完之后刷新父组件
    appendComment(item) {
      if (this.filters.operationName == '' && this.filters.diagnose == '') {
        this.query(this.filters.pagination.page);
      } else {
        this.query(1);
      }
    },
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 350
  },
  mounted() {
    /*this.init();*/
    this.query(this.filters.pagination.page);
  },
  watch: {
    $route(to, from) {
      this.query(this.filters.pagination.page);
    },
  },
};
</script>
<style scoped>
@import "../../assets/css/main.css";
.pageInput >>> .el-input__inner {
  width: 400px;
  height: 38px;
  background: #f6f7fb;
  border-radius: 23px;
  border: none;
}

.pageInput >>> .el-button {
  height: 34px;
  border-radius: 17px;
  border: 1px solid #979797;
  line-height: 5px;
  margin-left: 8px;
}
</style>
